export abstract class DownloadException extends Error {

}
